import Vue from 'vue'
import topic from '@/api/topic'
import store from '../store'
function getTopic (params) {
  return new Promise((resolve, reject) => {
    topic.getTopic(params).then(res => {
      const topicRes = res.data
      if (topicRes && topicRes.obj) {
        store.commit('editor/setPageSet', topicRes.obj.elements)
        store.commit('editor/setHead', topicRes.map.topic)
        store.commit('editor/setSuspComps', topicRes.obj.other && topicRes.obj.other.suspComps)
        store.commit('editor/setFloorNavComps', topicRes.obj.other && topicRes.obj.other.floorNavComps)

        const topicComps = topicRes.obj.model || []
        const cmps = topicComps.filter(cmp => {
          cmp.active = false
          return cmp.type !== 'placeholder'
        })
        store.commit('editor/setComponents', cmps)
      } else {
        Vue.$message.error(topicRes.msg || '服务器繁忙，请稍后重试！')
      }
      resolve(res.data)
    }).catch(err => {
      err && console.warn(err)
      // eslint-disable-next-line
      reject()
    })
  })
}

function install () {
  Vue.topic = Vue.prototype.topic = {
    getTopic
  }
}

Vue.use(install)

export default install
